import {
  RowDataObject,
  RowData,
  RowDataReducerActionPayload,
  RowDataReducerState,
  RowDataValueType,
} from "../../../types";

export const updateResetFieldAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const {
    propertyKey,
    newFieldValue,
    rowIndex,
    propertySubKey,
    selectedTabSectionKey,
  } = payload;

  if (!propertyKey || newFieldValue === undefined) return state;

  if (rowIndex !== undefined && propertySubKey && selectedTabSectionKey) {
    return updateNestedArrayObjectField(
      propertyKey,
      newFieldValue,
      propertySubKey,
      rowIndex,
      selectedTabSectionKey,
      state,
    );
  }

  if (rowIndex !== undefined && propertySubKey) {
    return updateArrayObjectField(
      propertyKey,
      newFieldValue,
      propertySubKey,
      rowIndex,
      state,
    );
  }

  if (propertySubKey) {
    return updateNestedObjectField(
      propertySubKey,
      newFieldValue,
      propertyKey,
      state,
    );
  }

  if (selectedTabSectionKey) {
    return updateNestedObjectField(
      propertyKey,
      newFieldValue,
      selectedTabSectionKey,
      state,
    );
  }

  return updateObjectField(propertyKey, newFieldValue, state);
};

const updateNestedArrayObjectField = (
  propertyKey: string,
  newFieldValue: RowDataValueType,
  propertySubKey: string,
  rowIndex: number,
  selectedTabSectionKey: string,
  state: RowDataReducerState,
): RowDataReducerState => {
  const currentArray =
    ((state.resetState?.rowData?.[selectedTabSectionKey] as RowData)?.[
      propertyKey
    ] as RowDataObject[]) ?? [];

  const updatedArray = currentArray.map((item, index) =>
    index === rowIndex ? { ...item, [propertySubKey]: newFieldValue } : item,
  );

  const updatedRowData = {
    ...state.resetState?.rowData,
    [selectedTabSectionKey]: {
      ...(state.resetState?.rowData?.[selectedTabSectionKey] as RowData),
      [propertyKey]: updatedArray,
    },
  } as RowData;

  return {
    ...state,
    resetState: {
      ...state.resetState,
      rowData: updatedRowData,
    },
  };
};

const updateArrayObjectField = (
  propertyKey: string,
  newFieldValue: RowDataValueType,
  propertySubKey: string,
  rowIndex: number,
  state: RowDataReducerState,
): RowDataReducerState => {
  const currentArray =
    (state.resetState?.rowData?.[propertyKey] as RowDataObject[]) ?? [];

  const updatedArray = currentArray.map((item, index) =>
    index === rowIndex ? { ...item, [propertySubKey]: newFieldValue } : item,
  );

  const updatedRowData = {
    ...(state.resetState?.rowData ?? {}),
    [propertyKey]: updatedArray,
  } as RowData;

  return {
    ...state,
    resetState: {
      ...state.resetState,
      rowData: updatedRowData,
    },
  };
};

const updateNestedObjectField = (
  propertyKey: string,
  newFieldValue: RowDataValueType,
  selectedTabSectionKey: string,
  state: RowDataReducerState,
): RowDataReducerState => {
  const updatedNestedRowData = {
    ...(state.resetState?.rowData ?? {}),
    [selectedTabSectionKey]: {
      ...(state.resetState?.rowData?.[selectedTabSectionKey] as RowDataObject),
      [propertyKey]: newFieldValue,
    },
  } as RowData;

  return {
    ...state,
    resetState: {
      ...state.resetState,
      rowData: updatedNestedRowData,
    },
  };
};

const updateObjectField = (
  propertyKey: string,
  newFieldValue: RowDataValueType,
  state: RowDataReducerState,
): RowDataReducerState => {
  const updatedRowData: RowData = {
    ...(state.resetState?.rowData ?? {}),
    [propertyKey]: newFieldValue,
  };

  return {
    ...state,
    resetState: {
      ...state.resetState,
      rowData: updatedRowData,
    },
  };
};
